import { render, staticRenderFns } from "./ServiceTypeBadge.vue?vue&type=template&id=a6d5060c&scoped=true"
import script from "./ServiceTypeBadge.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d5060c",
  null
  
)

export default component.exports